import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Source } from 'src/app/models/source';
import { ZbResponseStatusCodes } from 'src/app/models/zb-response';
import { MainAppService } from 'src/app/services/main-app.service';

@Component({
  selector: 'app-marketing-channels-detail',
  templateUrl: './marketing-channels-detail.component.html',
  styleUrls: ['./marketing-channels-detail.component.css']
})
export class MarketingChannelsDetailComponent implements OnInit {

  public data:Source;
  
  constructor(
    public mainAppService: MainAppService,
    public dialogRef: MatDialogRef<MarketingChannelsDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: Source) {
      this.data = _data;
    }

    ngOnInit(): void { }

    customCompare(o1, o2) {
      return o1 == o2;
    }

    save(){
      this.mainAppService.postSource(this.data).subscribe(result =>{
        if (result && result.responseData &&  result.statusCode == ZbResponseStatusCodes.OK ){
          this.dialogRef.close();
        }
      })
    }

    delete(){
      this.mainAppService.deleteSource(this.data).subscribe(result =>{
        if (result && result.responseData &&  result.statusCode == ZbResponseStatusCodes.OK ){
          this.dialogRef.close();
        }
      })
    }
}
